import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectModel } from '../redux/carDuck';
import { fetchModels } from '../redux/apiDuck';
import { useHistory } from 'react-router-dom';
import ListItem from '../components/ListItem';
import List from '../components/List';
import Card from '../components/Card';
import Typography from '../components/Typography';
import Loader from '../components/Loader';

export const SecondStep = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { models, fetching } = useSelector((state) => state.api);
  const { brandID } = useSelector((state) => state.car);

  useEffect(() => {
    dispatch(fetchModels(brandID));
  }, [dispatch, brandID]);

  const handleSelectModel = ({ descripcion }) => {
    dispatch(selectModel(descripcion));

    history.push('/anios');
  };

  const deleteNullModels = (models) => models.filter((model) => model.codigo !== '');

  if (fetching) return <Loader />;

  return (
    <>
      <Typography text='¿Cúal es el modelo de tu auto?' />
      <Card>
        <List>
          {deleteNullModels(models).map((model) => (
            <ListItem
              key={model.codigo}
              text={model.descripcion}
              handleClick={() => handleSelectModel(model)}
            />
          ))}
        </List>
      </Card>
    </>
  );
};
